import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const ShiptIcon = ({
  width = '50',
  height = '50'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <IconSvg
      style={{
        width: width,
        height: height
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
    >
      <path d="M0 0h150v150H0V0z" fill="none" />
      <path
        d="M77.6 140.6c-13.8 0-27.4-2.6-40.2-7.6-6.6-2.6-10.7-9.2-10.2-16.3L30.8 58l17.9 1.1-3.5 57.7c20.9 7.9 44 7.9 64.9-.1-.4-6.5-2.7-40.5-4.2-60.4-17.9 9-33 9.7-44.1 1.9-7-5-11.1-13-11-21.6-.1-9 4.2-17.4 11.5-22.7 6.4-4.7 14.6-6.2 22.2-4.1 8.5 2.3 15.9 8.8 19.9 17.4l-16.3 7.5c-1.7-3.8-4.9-6.7-8.2-7.6-2.5-.7-5.2-.1-7.3 1.5-2.5 1.9-4 4.9-3.9 8-.1 2.7 1.2 5.4 3.4 7 6.8 4.8 20.6 1.1 36.8-9.7 2.8-1.9 6.5-2 9.4-.3 4.2 2.4 4.4 5.8 4.7 10.4l5 72.6c.6 7.1-3.6 13.8-10.3 16.4-12.7 5-26.4 7.6-40.1 7.6z"
        fill="#23cc6b"
      />
    </IconSvg>
  )
}

export default ShiptIcon
